define(require => {
  const Modal = require('backbone.modal');
  const _ = require('underscore');
  let buildTemplate;
  var RhythmModal = Modal.extend({
    isDomRefresh: false,
    onDomRefresh: function() {
      if (this.getOption('isDomRefresh')) {
        this.$el.modal({
          trigger: 'immediate',
        });
      }
    },
  });

  // Add t function as a "templatehelper" for the modals
  buildTemplate = Modal.prototype.buildTemplate;
  RhythmModal.prototype.buildTemplate = function(template, data) {
    _data = _.extend(data, {
      t: App.t,
      tr: function(context, options) {
        var opts = i18n.functions.extend(options.hash, context);
        if (options.fn) {
          opts.defaultValue = options.fn(context);
        }
        return new Handlebars.SafeString(i18n.t(opts.key, opts));
      },
    });
    return buildTemplate(template, _data);
  };
  return RhythmModal;
});
